import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import "./HomeCatComp.css";
import yacht from "./../Assets/Yacht1.jpg";
import Carousel from "react-multi-carousel";
import Car from "./../Assets/Car.jpg";
import Home from "./../Assets/home.jpeg";
import Helicopter from "./../Assets/helicopter.jpg";
import Plane from "./../Assets/plane.jpg";
import Slider from "react-slick";
import { SampleNextArrow, SamplePrevArrow } from "./HomeCaroused";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { daDK } from "@mui/material/locale";

var cart = "a";

const HomeCatComp = () => {
  const [windowWidth, setWindowWidth] = useState(window.outerWidth);
  window.addEventListener("resize", function () {
    setWindowWidth(window.outerWidth);
  });

  const [skeletonScreen, setSkeletonScreen] = useState(false);
  useEffect(() => {
    if (cart == "a") {
      setSkeletonScreen(true);
      setTimeout(() => {
        cart = "b";
        setSkeletonScreen(false);
      }, 5000);
    }
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    // speed: 500,
    slidesToShow:
      windowWidth > 1000
        ? 4
        : windowWidth > 650
        ? 3
        : windowWidth > 500
        ? 2
        : 1,
    slidesToScroll: 1,
  };

  return (
    <div
      className="HomeCatCompMain 
        "
    >
      <p
        className="homeCatCatTitle"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
      >
        Categories
      </p>
      {/* <hr className='homeCatHr' /> */}
      <Slider
        {...settings}
        arrows={false}
        // arrows={true}
        zIndex={2}
        className={"as"}
        centerPadding={"40px"}
        prevArrow={<SamplePrevArrow />}
        nextArrow={<SampleNextArrow />}
        dots={false}

        // fade= "fals"
        
    autoplay= {true}
    autoplaySpeed= {5000}
    pauseOnHover={true}

        

      >
        {/* <div className="ass 
      col-md-12 row d-flex justify-content-between"> */}


        <div className="homeCatSubDiv">
          {skeletonScreen?<Skeleton  className="homeCatSubDivImg"/>:<img src={yacht} className="homeCatSubDivImg" />}
          {skeletonScreen?<Skeleton  className="mt-3 ske"/>:<p className="homeCatSubDivTxt">Yacht</p>}
        </div>
        <div className="homeCatSubDiv">
        {skeletonScreen?<Skeleton  className="homeCatSubDivImg"/>: <img src={Home} className="homeCatSubDivImg" />}
          {skeletonScreen?<Skeleton  className="mt-3 ske"/>:<p className="homeCatSubDivTxt">Home</p>}
        </div>
        <div className="homeCatSubDiv">
        {skeletonScreen?<Skeleton  className="homeCatSubDivImg"/>:  <img src={Car} className="homeCatSubDivImg" />}
          {skeletonScreen?<Skeleton  className="mt-3 ske"/>: <p className="homeCatSubDivTxt">Car</p>}
        </div>
        <div className="homeCatSubDiv">
        {skeletonScreen?<Skeleton  className="homeCatSubDivImg"/>: <img src={Plane}  className="homeCatSubDivImg" />}
          {skeletonScreen?<Skeleton  className="mt-3 ske"/>:<p className="homeCatSubDivTxt">Plane</p>}
        </div>
        <div className="homeCatSubDiv">
        {skeletonScreen?<Skeleton  className="homeCatSubDivImg"/>: <img src={Helicopter} className="homeCatSubDivImg" />}
          {skeletonScreen?<Skeleton  className="mt-3 ske"/>:<p className="homeCatSubDivTxt">Helicopter</p>}
        </div>

        {/* </div> */}
      </Slider>
    </div>
  );
};
// https://www.helispirit.com.au/wp-content/uploads/2018/12/Karratha-red-heli-1.jpeg
export default HomeCatComp;
